import { makeStyles } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { useQueryClient } from '@tanstack/react-query';
import clsx from 'clsx';
import { isEmpty } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from 'src/constants';
import useApi from 'src/hooks/useApi';
import useCustomSnackbarGlobal from 'src/hooks/useSnackbarGlobal';
import ApiService from 'src/modules/api-service';

import BinocularsIcon from './BinocularsIcon';

type WatchlistBadgeProps = {
  watchlist?: string[];
  vin?: string;
};

const useStyles = makeStyles((theme) => ({
  detailIcon: {
    color: theme.palette.secondary.main,
    background: grey[200],
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 50,
    height: '25px',
    padding: 0,
    paddingRight: '2px',
  },
  active: {
    color: theme.palette.watchlistIconActive,
  },
}));

const WatchlistIcon = ({ vin, watchlist }: WatchlistBadgeProps) => {
  const classes = useStyles();
  const { fetch } = useApi();
  const { t } = useTranslation();
  const snackbar = useCustomSnackbarGlobal();
  const queryClient = useQueryClient();
  const [isOnWatchlist, setOnWatchlist] = useState<boolean>(!isEmpty(watchlist));

  const addToDefaultWatchlist = async () => {
    if (!vin) return;
    const response = await fetch(ApiService.watchListController.watchListControllerAddCarToDefaultWatchList({ vin }));
    if (response && response.status === 200) {
      snackbar.showSuccess(t('snackBar.success.addedToWatchlist'));
      setOnWatchlist(true);
    } else {
      snackbar.showError(t('snackBar.error.addedToWatchlist'));
    }
    // invalidate query key to reload data
    queryClient.invalidateQueries([QueryKeys.carDetail]);
    queryClient.invalidateQueries([QueryKeys.carsList]);
  };

  const removeFromDefaultWatchlist = async () => {
    if (!vin) return;
    const response = await fetch(
      ApiService.watchListController.watchListControllerRemoveCarFromDefaultWatchList({ vin }),
    );
    if (response && response.status === 204) {
      snackbar.showSuccess(t('snackBar.success.removedFromWatchlist'));
      setOnWatchlist(false);
    } else {
      snackbar.showError(t('snackBar.error.removeFromWatchlist'));
    }
    // invalidate query key to reload data
    queryClient.invalidateQueries([QueryKeys.carDetail]);
    queryClient.invalidateQueries([QueryKeys.carsList]);
  };

  if (isOnWatchlist)
    return (
      <BinocularsIcon
        className={clsx(classes.detailIcon, classes.active)}
        onClick={() => removeFromDefaultWatchlist()}
      />
    );
  return <BinocularsIcon className={classes.detailIcon} onClick={() => addToDefaultWatchlist()} />;
};

export default WatchlistIcon;
